export default {
  durationMinutes: '{m}m',
  durationHours: '{h}h {mm}m',
  agoSeconds: '{n}s ago',
  agoMinutes: '{n}m ago',
  agoHours: '{n}h ago',
  errorForbidden: "You don't have access to this.",
  errorNotFound: 'Not found.',
  errorTooLarge: 'That upload is too large to send.',
  errorRequestFailed: 'Request failed ({status})',
  errorNetwork: "Can't reach the server. Check your connection and try again.",
  loginMfaRequired: 'Enter the 6-digit code from your authenticator app.',
  loginInvalidMfa: "That code didn't work. Check the code and try again.",
  loginIncorrect: 'Incorrect email or password.',
  loginTooMany: 'Too many attempts. Try again in a minute.',
  fieldInvalid: 'Invalid',
  networkError: 'Cannot reach the server',
  sessionExpired: 'Your session has expired. Please sign in again.',
  alertRego: 'Rego',
  alertInsurance: 'Insurance',
  alertWarranty: 'Warranty',
  alertService: 'Service',
  expiryOverdue: 'overdue',
  expiryDueSoon: 'due soon',
  expiryNone: 'none logged',
  expiryOk: 'ok',
  categoryLaptop: 'Laptop',
  categoryPhone: 'Phone',
  categoryTablet: 'Tablet',
  categoryVehicle: 'Vehicle',
  categoryTool: 'Tool',
  categorySafetyGear: 'Safety gear',
  categoryUniform: 'Uniform',
  categoryOther: 'Other',
  statusOk: 'OK',
  deviceNotPaired: 'Not paired',
  deviceNotPairedHint: 'No device paired.',
  deviceNeverContacted: 'Never contacted',
  deviceNeverContactedHint: "Paired, but this device hasn't made an authenticated request yet.",
  deviceNotResponding: 'Not responding',
  deviceNotRespondingHint: 'Last contact {ago} — the app may have stopped running in the background. Ask them to reopen it.',
  deviceLastContact: 'Last contact {ago}.',
  deviceNotCheckingInHint: "Last check-in {ago}. This phone normally checks in about every {minutes} minutes (less often while it lies still), so the app may have been uninstalled or force-stopped, or the phone is off or has no signal.",
  deviceAppRemoved: 'App removed',
  deviceAppRemovedHint: "The push service reported the app uninstalled {ago}. They can't report arriving or leaving until it is reinstalled and paired again.",
  lastHeard: 'Heard {ago}',
  lastHeardHint: 'Their phone last checked in {ago}.',
  lastHeardQuietHint: 'Nothing from their phone {ago}, so "on site" is the last known state rather than a live reading. It closes automatically if the phone stays silent.',
  tenure: '{years} {months}',
  yearOne: '{count} year',
  yearOther: '{count} years',
  monthOne: '{count} month',
  monthOther: '{count} months',
  fileContract: 'Contract',
  fileLicence: 'Licence',
  fileCertificate: 'Certificate',
  fileIdentification: 'Identification',
  fileMedical: 'Medical',
  fileOther: 'Other',
  uploadBadType: 'Upload a PDF, image, Word or Excel document, or a text/CSV file.',
  uploadEmpty: 'That file is empty.',
  uploadTooLarge: 'Files can be up to 10 MB.',
  permLocation: 'Location',
  permBackgroundLocation: 'Background location',
  permPreciseLocation: 'Precise location',
  permNotifications: 'Notifications',
  permUnknown: 'Unknown',
  permUnknownHint: "This phone hasn't reported its permission status yet.",
  permAllGranted: 'All permissions granted.',
  permOff: '{permission}: off',
  permActionNeeded: 'Action needed',
  imageNoCanvas: 'Canvas is not available in this browser.',
  imageProcessFailed: 'Could not process that image.',
  logoTooLarge: 'That logo is too detailed to fit under 512 KB. Try a simpler image.',
  siteUploadBadType: 'Upload a PDF, image, Office document, drawing, zip or text/CSV file.',
  photoProcessFailed: 'Could not process that photo.',
}
